import { render, staticRenderFns } from "./MaterialReturnConfirm.vue?vue&type=template&id=40e35361&scoped=true"
import script from "./MaterialReturnConfirm.vue?vue&type=script&lang=js"
export * from "./MaterialReturnConfirm.vue?vue&type=script&lang=js"
import style0 from "./MaterialReturnConfirm.vue?vue&type=style&index=0&id=40e35361&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e35361",
  null
  
)

export default component.exports